import React from 'react';

import { Box, Typography } from '@mui/material';
import Description from '@common/components/Description';
import renderChunkContent from 'modules/Programs/utils/renderChunkContent';

import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IGradeBookModel } from '@common/models/GradeBooks/GradeBook';

interface PropsType {
	chunkModel: IChunkModel;
	hideTitle?: boolean;
	gradeBook: IGradeBookModel;
	disabled: boolean;
}

function Chunk({ chunkModel, gradeBook, hideTitle = false, disabled = false }: PropsType) {
	return (
		<Box
			sx={{
				display: 'flex',
				background: 'transparent',
				flexDirection: 'column',
				gap: '8px',
				overflow: 'hidden',
			}}
		>
			{!hideTitle && (
				<Box
					sx={{
						width: '100%',
						minHeight: '56px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						padding: '8px 16px',
						gap: '16px',
					}}
					component="div"
				>
					<Typography component="h2" sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 400 }}>
						{chunkModel.name}
					</Typography>
				</Box>
			)}
			<Description html={chunkModel.description} />
			{renderChunkContent(chunkModel, gradeBook, disabled)}
		</Box>
	);
}

export default Chunk;
